export const MAX_PDF_SETTING_VALUE = 30;